import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { theme } from "src/config";
import { ResidentialZoneRestrictionsDialog } from "src/components/ResidentialZoneRestrictionsDialog";

interface Props {}

export function ResidentialZoneRestrictionsPage(props: Props) {
  const {
    caseId = "",
    scenarioId = "",
    residentialZoneId = "",
  } = useParams<{
    caseId: string;
    scenarioId: string;
    residentialZoneId: string;
  }>();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  function close() {
    setOpen(false);

    setTimeout(() => {
      navigate(`/cases/${caseId}/scenarios/${scenarioId}/residential-zones/${residentialZoneId}`);
    }, theme.transitions.duration.leavingScreen);
  }

  return render();

  function render() {
    return (
      <>
        {open && (
          <ResidentialZoneRestrictionsDialog
            onClose={close}
            scenarioId={scenarioId}
            residentialZoneId={residentialZoneId}
          />
        )}
      </>
    );
  }
}
